import { Glyphicon, Label, Well } from 'react-bootstrap';
import styled from 'styled-components';
import { steps } from '.';

export const ArrowWrapper = styled.div`
    & > .glyphicon {
        font-size: 10px;
        margin-right: 10px;
        padding-bottom: 5px;
        color: #ccc;
    }
`;

export const StepWrapper = styled.div`
    margin-right: 10px;
`;

export const ActiveStepWrapper = styled(Label)`
    margin-right: 10px;
    font-size: 100%;
    padding-top: 5px;
    padding-bottom: 5px;
`;

interface IProps {
    currentStep: number
}

const Progress = (props: IProps) => {
    const getSteps = () => {
        let results = [];

        steps.forEach((step, index) => {
            if (props.currentStep != index + 1) {
                results.push(<StepWrapper>{step.label}</StepWrapper>);
            } else {
                results.push(<ActiveStepWrapper bsStyle='primary'><strong>{step.label}</strong></ActiveStepWrapper>);
            }

            if (index < steps.length - 1) {
                results.push(<ArrowWrapper><Glyphicon glyph='forward' /></ArrowWrapper>);
            }
        });

        return results;
    };

    return (
        <Well className='text-center' style={{ paddingTop: 5, paddingBottom: 5, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {getSteps()}
        </Well>
    );
}

export default Progress;